'use client';

import { ReactNode } from 'react';

import { cn } from '@/lib/ui/cn';
import { ProgressBar } from './ProgressBar';
import { WizardMobileBackButton } from './WizardMobileBackButton';

interface WizardLayoutProps {
  children: ReactNode;
  currentStepIndex: number;
  totalSteps: number;
  hideProgress?: boolean;
  hideMobileBackButton?: boolean;
  mobileBackButton?: React.ReactNode;
  className?: string;
}

/**
 * Layout wrapper for wizard steps.
 *
 * Provides:
 * - Progress bar (optional)
 * - Mobile back button (optional, hidden when step renders its own)
 * - Consistent padding and max-width
 */
export function WizardLayout({
  children,
  currentStepIndex,
  totalSteps,
  hideProgress = false,
  hideMobileBackButton = false,
  mobileBackButton,
  className,
}: WizardLayoutProps) {
  return (
    <div className={cn('flex flex-1 flex-col', className)}>
      {/* Progress bar with padding */}
      {!hideProgress && (
        <div className='bg-[#F7F5EF] py-4'>
          <div className='mx-auto w-full max-w-2xl px-4 lg:px-8'>
            <ProgressBar
              currentStep={currentStepIndex}
              totalSteps={totalSteps}
            />
          </div>
        </div>
      )}

      {/* Content section */}
      <div className='flex flex-1 flex-col bg-[#FDFDFD]'>
        {!hideMobileBackButton &&
          (mobileBackButton ?? <WizardMobileBackButton />)}
        <div className='flex flex-1 flex-col items-center justify-center'>
          {children}
        </div>
      </div>
    </div>
  );
}
